export const changeCoins = (state) => state.coinsRequest.coins